import { saveAs } from 'file-saver';

type DownloadFileOptions = {
  fileName?: string;
  includeDate?: boolean;
};

function addDateToFilename(fileName: string): string {
  const dateString = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
  const dotIndex = fileName.lastIndexOf('.');

  return dotIndex > 0
    ? `${fileName.slice(0, dotIndex)}-${dateString}${fileName.slice(dotIndex)}`
    : `${fileName}-${dateString}`;
}

/**
 * Downloads a file from a URL or Blob with custom filename options
 * @param urlOrBlob - URL string or Blob object to download
 * @param options - Configuration options for the download
 */
export async function downloadFile(
  urlOrBlob: string | Blob,
  options: DownloadFileOptions = {},
): Promise<void> {
  const { fileName = 'download', includeDate = false } = options;
  const finalFilename = includeDate ? addDateToFilename(fileName) : fileName;

  if (urlOrBlob instanceof Blob) {
    saveAs(urlOrBlob, finalFilename);
    return;
  }

  try {
    const response = await fetch(urlOrBlob);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    saveAs(blob, finalFilename);
  } catch {
    saveAs(urlOrBlob, finalFilename);
  }
}
